import { render, staticRenderFns } from "./BlockRole.vue?vue&type=template&id=78dae5f6&scoped=true"
import script from "./BlockRole.vue?vue&type=script&lang=ts"
export * from "./BlockRole.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78dae5f6",
  null
  
)

export default component.exports